__turbopack_context__.v({
  "backBtn": "styles-module__B8UpyG__backBtn",
  "backIcon": "styles-module__B8UpyG__backIcon",
  "catalogBody": "styles-module__B8UpyG__catalogBody",
  "closeBtn": "styles-module__B8UpyG__closeBtn",
  "fabFilters": "styles-module__B8UpyG__fabFilters",
  "fabList": "styles-module__B8UpyG__fabList",
  "filterBtn": "styles-module__B8UpyG__filterBtn",
  "filtersBody": "styles-module__B8UpyG__filtersBody",
  "filtersHeader": "styles-module__B8UpyG__filtersHeader",
  "filtersOverlay": "styles-module__B8UpyG__filtersOverlay",
  "leftContent": "styles-module__B8UpyG__leftContent",
  "leftContentMobile": "styles-module__B8UpyG__leftContentMobile",
  "leftHeader": "styles-module__B8UpyG__leftHeader",
  "leftPane": "styles-module__B8UpyG__leftPane",
  "map": "styles-module__B8UpyG__map",
  "mapPane": "styles-module__B8UpyG__mapPane",
  "mobileMap": "styles-module__B8UpyG__mobileMap",
  "mobileWrap": "styles-module__B8UpyG__mobileWrap",
  "open": "styles-module__B8UpyG__open",
  "overlay": "styles-module__B8UpyG__overlay",
  "overlayBody": "styles-module__B8UpyG__overlayBody",
  "overlayHeader": "styles-module__B8UpyG__overlayHeader",
  "typeCatalogTitle": "styles-module__B8UpyG__typeCatalogTitle",
  "wrap": "styles-module__B8UpyG__wrap",
});
